// extracted by mini-css-extract-plugin
module.exports = {"bumpLeft":"MarketSpotlightText_bumpLeft__36LeM","bumpDown":"MarketSpotlightText_bumpDown__1JOQE"};